/**
 * MobileInstrumentList Component
 *
 * Mobile page for displaying instruments management.
 * Route: /settings/portfolio/reference-data/instruments (mobile only)
 *
 * Renders ReferenceDataMobileHeader (Select-as-title switcher) + UserInstrumentsTab
 * which has full mobile UX: simplified AG Grid columns, action
 * bottom sheet, inline search, filter drawer.
 */

// 1. External dependencies
import React from 'react';

// 2. Internal absolute imports
import { UserInstrumentsTab } from '@/components/shared/InstrumentExplorer/UserInstrumentsTab';

// 3. Internal — relative imports
import { ReferenceDataMobileHeader } from '../components';

export const MobileInstrumentList: React.FC = () => {
  return (
    <div className="flex flex-col h-full">
      {/* Reference Data Header — Select-as-title switcher */}
      <ReferenceDataMobileHeader activeSection="instruments" />

      {/* Instruments content — UserInstrumentsTab handles full mobile UX */}
      <div className="flex-1 min-h-0">
        <UserInstrumentsTab />
      </div>
    </div>
  );
};
